export default "__VITE_ASSET__CAsFDDct__"